import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  display: 'block',
  width: 'calc(100% - 40px)',
  margin: '0 auto',
  background: '#efefec',
  borderRadius: '8px',
  padding: '2px',
  overflow: 'hidden'
};

export const innerContainerStyle: CSSProperties = {
  display: 'flex',
  width: '100%'
};

export const tabStyle: CSSProperties = {
  flex: '1',
  padding: '12px',
  fontSize: '13px',
  fontWeight: '500',
  cursor: 'pointer',
  borderRadius: '8px',
  textAlign: 'center'
};

export const activeTabStyle: CSSProperties = {
  backgroundColor: '#000',
  color: '#FFF'
};

export const inactiveTabStyle: CSSProperties = {
  backgroundColor: 'transparent',
  color: '#000'
};
